import API from '../utils/api';
import { BACK_OFFICE_API_ENDPOINT } from '../constants/defaultValues';

const getLastAccountingPeriod = async params => {
    try {
        const res = await API.get(`${BACK_OFFICE_API_ENDPOINT}/static/data/last-period`, {
            params,
        });

        return res.data;
    } catch (error) {
        console.error(error);

        return { info: { success: false } };
    }
};

const StaticDataService = {
    getLastAccountingPeriod,
};

export default StaticDataService;
